/**
 * Zoom Chrome Extension
 *
 * Exposes its injected observer bundle and UI images to every origin.
 *
 * Manifest verified against version 1.9.14.
 */

import { probeFetch, probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'kgjfgplpablkjnlkjmjdecgdpfankdle';

export const zoom: ExtensionDefinition = {
  id: ID,
  name: 'Zoom Chrome Extension',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 7_000_000,
  signals: [
    {
      id: 'war-injectobserver',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/injectobserver.bundle.js — the script Zoom injects to watch for ' +
        'meeting links, exposed to <all_urls>.',
      weight: 1,
      run: () => probeFetch(ID, 'js/injectobserver.bundle.js'),
    },
    {
      id: 'war-select2-image',
      kind: 'web-accessible-resource',
      description: 'Load images/select2.png via <img> to corroborate without needing CORS.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/select2.png'),
    },
  ],
};
